import React from 'react'
import WPCOMLogo from './wpcomlogo'

class WPCOMHeader extends React.Component {
	render() {
		document.body.style = 'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
		return <div className="wpcom">
			<div className="wpcom-migration-header">
				<div className="wpcom-migration-header__wpcom-logo">
					<WPCOMLogo />
				</div>

				<div className="wpcom-migration-header__blogvault-logo">
					Powered by <img src="/assets/migration/wpcom-blogvault-logo.png" alt="blogvault-logo"/>
				</div>
			</div>
		</div>
	}
}

export default WPCOMHeader
